import { useSnackbar } from 'notistack';
import { useEffect, useRef } from 'react';

import { onPaywall } from '../../api/paywallErrorBridge';

const MENSAJES = {
  payment_required: 'Esta acción requiere un plan pagado.',
  limit_reached: 'Llegaste al límite de tu plan para esta acción.',
  rate_limited: 'Llegaste al máximo de veces por ciclo para esta acción.',
};

const DEDUP_MS = 8000;

/**
 * Avisa con un snackbar warning cuando el muro de pago responde 402.
 * Debe montarse bajo <SnackbarProvider>. No renderiza nada.
 */
export function PaywallSnackbarHandler() {
  const { enqueueSnackbar } = useSnackbar();
  const vistos = useRef(new Map());

  useEffect(() => {
    const unsubscribe = onPaywall((detail) => {
      const mensaje = MENSAJES[detail?.reason];
      if (!mensaje) return;

      const clave = `${detail.reason}:${detail.feature ?? ''}`;
      const ahora = Date.now();
      const ultimo = vistos.current.get(clave);
      if (ultimo !== undefined && ahora - ultimo < DEDUP_MS) return;
      vistos.current.set(clave, ahora);

      enqueueSnackbar(mensaje, { variant: 'warning' });
    });
    return unsubscribe;
  }, [enqueueSnackbar]);

  return null;
}

export default PaywallSnackbarHandler;
